import { useGetMachinesQuery } from '../../../store/api/machines-api'
import { Filters } from '../../../types/strapi/strapi'

export default function useGetFlexographyMachines() {
    return useGetMachinesQuery({
        filters: {
            $or: [
                {
                    machine_print_type: {
                        name: {
                            $in: ['flexography', 'dummy', 'digital'],
                        },
                    },
                },
                {
                    machine_brand: {
                        name: {
                            $in: ['DMS', 'Термо'],
                        },
                    },
                },
            ],
        } as Filters,
        populate: {
            machine_brand: true,
        },
    })
}
